// extracted by mini-css-extract-plugin
module.exports = {"bannerImage":"styles-module__bannerImage___3P6vo"};